import { render } from "./TextContact.vue?vue&type=template&id=265e5b6e"
const script = {}

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__